import { useState, useCallback, useEffect } from "react";
import { useSimpleRegistrationContext } from "pages/SimpleRegistrationsPage";
import { useApi } from "providers/ApiProvider";
import { Box as MuiBox, styled as muiStyled } from "@mui/material";
import { DialButton } from "./DialButton";

const Box = muiStyled(MuiBox)`
  &.container {
    width: 100%;
    height: 100%;
  }

  &.content {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 3%;
  }

  &.title {
    font-size: 4vw;
    font-weight: bold;
    margin-bottom: 40px;

    b {
      font-weight: 800;
    }
  }

  &.buttons-container {
    display: flex;
    flex-direction: column;
    gap: 5vw;
  }

  &.button-row {
    display: flex;
    justify-content: space-between;
  }

  &.button-text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const PortraitAcquisitionChannelsSelect = () => {
  const { acquisitionChannelsIds, setAcquisitionChannelsIds } =
    useSimpleRegistrationContext();

  const { customersApi } = useApi();
  const [acquisitionChannels, setAcquisitionChannels] = useState([]);

  const loadAcquisitionChannels = useCallback(async () => {
    const res = await customersApi.getAcquisitionChannels({
      limit: 12,
      orderBy: "order desc",
      visible: true,
      registrationView: true,
    });
    const payload = await res.data;
    payload.data && setAcquisitionChannels(payload.data.slice(0, 12));
  }, [customersApi]);

  useEffect(() => {
    loadAcquisitionChannels();
  }, []);

  const onClickSelect = (id: number) => {
    if (acquisitionChannelsIds.indexOf(id) > -1) {
      const update = [...acquisitionChannelsIds];
      update.splice(acquisitionChannelsIds.indexOf(id), 1);
      setAcquisitionChannelsIds(update);
    } else {
      const update = [...acquisitionChannelsIds];
      update.push(id);
      setAcquisitionChannelsIds(update);
    }
  };

  const AcquisitionChannelsButtons = () => {
    const buttons = acquisitionChannels.map(
      (v: { id: number; name: string }) => (
        <DialButton
          key={v.id}
          text={v.name}
          onClick={() => onClickSelect(v.id)}
          selected={acquisitionChannelsIds.indexOf(v.id) > -1}
          disabled={
            acquisitionChannelsIds.indexOf(v.id) === -1 &&
            acquisitionChannelsIds.length === 3
          }
        />
      )
    );
    const divList = [];
    for (let i = 0; i < buttons.length; i += 2) {
      divList.push(
        <Box className="button-row" key={i}>
          {buttons.slice(i, i + 2)}
        </Box>
      );
    }
    return <>{divList}</>;
  };

  return (
    <Box className="container">
      <Box className="content">
        <Box className="title">
          <b>내원경로</b>를 선택하세요 (최대 3개)
        </Box>
        <Box className="buttons-container">
          <AcquisitionChannelsButtons />
        </Box>
      </Box>
    </Box>
  );
};
